import React from 'react';
import { getPasswordStrengthFeedback } from '../../utils/passwordValidator';

/**
 * Visual password strength indicator component
 * Shows a colored bar and text feedback based on password strength
 */
const PasswordStrengthIndicator = ({ strength }) => {
  const feedback = getPasswordStrengthFeedback(strength);

  if (strength === 'none') {
    return null; // Don't show anything if no password
  }

  return (
    <div style={{
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: '0.25rem',
      }}>
        <div style={{
          flex: 1,
          height: '6px',
          backgroundColor: '#e0e0e0',
          borderRadius: '3px',
          overflow: 'hidden',
        }}>
          <div style={{
            height: '100%',
            width: `${feedback.percentage}%`,
            backgroundColor: feedback.color,
            transition: 'all 0.3s ease',
          }} />
        </div>
        <span style={{
          fontSize: '0.875rem',
          fontWeight: '600',
          color: feedback.color,
          minWidth: '80px',
          textAlign: 'right',
        }}>
          {feedback.text}
        </span>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;

